'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var Icon_1 = __importDefault(require('../Icon'));

var Security = function Security(props) {
  return react_1.default.createElement(
    Icon_1.default,
    __assign({}, props),
    react_1.default.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 7.38217V4.75411C7.48103 5.16255 9.6856 5.38777 12.0001 5.38777C14.3145 5.38777 16.519 5.16255 18.5 4.75414V8.9164L18.5 8.92748V8.92786C18.5 9.9659 18.381 10.9629 18.1606 11.9038L5.5 7.38217ZM5.50008 8.975C5.50178 9.46389 5.52987 9.94362 5.58252 10.4126L17.1881 14.5906C17.3897 14.1914 17.571 13.7749 17.7298 13.3428L5.50008 8.975ZM16.4095 15.9045L5.8916 12.1181C6.79186 15.6767 9.15174 18.3997 12 19.4421C13.7188 18.813 15.2598 17.5719 16.4095 15.9045ZM4.64184 3.01654C4.31939 2.93348 4 3.17355 4 3.50652V8.92746V8.92786C4 14.686 7.32864 19.5339 11.856 20.9779C11.9496 21.0078 12.0503 21.0078 12.144 20.9779C16.6713 19.5339 20 14.686 20 8.92786V8.92748L20 8.92744V3.50655C20 3.17358 19.6806 2.93351 19.3582 3.01656C17.2114 3.56949 14.6932 3.88777 12.0001 3.88777C9.30691 3.88777 6.7886 3.56948 4.64184 3.01654Z',
    })
  );
};

Security.displayName = 'Security';
exports.default = Security;
